import { useCallback, useEffect, useState } from "react";
import useMediaQuery from "../../hooks/useMediaQuery";

const SIDEBAR_COLLAPSED_STORAGE_KEY = "sidebarCollapsed";

export const RESPONSIVE_SHELL_MOBILE_QUERY = "(max-width: 768px)";

function readStoredSidebarCollapsed() {
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true";
    } catch (error) {
        return false;
    }
}

function writeStoredSidebarCollapsed(value) {
    try {
        localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(value));
    } catch (error) {
        // Layout remains usable if storage is unavailable.
    }
}

export default function useResponsiveShell(routeKey) {
    const isMobileShell = useMediaQuery(RESPONSIVE_SHELL_MOBILE_QUERY);
    const [isCollapsed, setIsCollapsed] = useState(readStoredSidebarCollapsed);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

    const closeMobileSidebar = useCallback(() => {
        setIsMobileSidebarOpen(false);
    }, []);

    const toggleSidebar = useCallback(() => {
        if (isMobileShell) {
            setIsMobileSidebarOpen(prev => !prev);
            return;
        }

        setIsCollapsed(prev => {
            const next = !prev;
            writeStoredSidebarCollapsed(next);
            return next;
        });
    }, [isMobileShell]);

    useEffect(() => {
        if (!isMobileShell) closeMobileSidebar();
    }, [closeMobileSidebar, isMobileShell]);

    useEffect(() => {
        closeMobileSidebar();
    }, [closeMobileSidebar, routeKey]);

    return {
        closeMobileSidebar,
        isCollapsed,
        isMobileShell,
        isMobileSidebarOpen,
        toggleSidebar,
    };
}
